import { ZContractStatus } from '../../model/schema'

const 계약 = {
  contractId: 4594,
  cid: 1827,
  week: 1,
  startDate: '2024-12-01',
  endDate: '2024-12-07',
  isExtend: false,
  totalUsingFee: 220000,
  usingFee: 300000,
  longTermDiscount: 50000,
  earlyDiscount: 50000,
  mgmtFee: 10000,
  cleanFee: 10000,
  serviceFee: 7260,
  hostPayAmount: 212740,
  refundType: 'MIDDLE',
  refundTerms: [
    {
      fromDate: null,
      toDate: '2025-06-03',
      fromDateDiffDays: null,
      toDateDiffDays: 15,
      cancelFeePercent: 10,
    },
    {
      fromDate: '2025-06-04',
      toDate: '2025-06-10',
      fromDateDiffDays: 14,
      toDateDiffDays: 8,
      cancelFeePercent: 30,
    },
    {
      fromDate: '2025-06-11',
      toDate: '2025-06-17',
      fromDateDiffDays: 7,
      toDateDiffDays: 1,
      cancelFeePercent: 50,
    },
    {
      fromDate: '2025-06-18',
      toDate: null,
      fromDateDiffDays: 0,
      toDateDiffDays: null,
      cancelFeePercent: null,
    },
  ],
  refundAmount: null,
  cancelFee: null,
  cancelFeePercent: 90,
  hostPayAmountBeforeOtherFee: null,
  refundAccountBankName: '신한은행',
  refundAccount: '1002123456789',
  contractRequestTime: '2025-05-30T15:25:20',
  contractCompleteTime: null,
  checkinTime: null,
  leaveConfirmTime: null,
  checkFinishTime: null,
  cancelTime: null,
  closedTime: null,
  rid: 1441,
  roomName: '서울 중구 편안한 쉼터',
  addrLot: '서울시 서초구 잠원동 15-10',
  addrStreet: '서울시 서초구 나루터로59',
  picMain: 'room/653306de-ab84-47dc-98c4-03236a926dd5.png',
  hostUid: 928,
  hostName: '이름입니다.',
  hostPhoneNumber: '010-1234-5667',
  guestUid: 941,
  guestName: '이름입니다.',
  guestPhoneNumber: '계약이 확정된 후 연락처가 공개됩니다.',
  isRefundAvailable: false,
  isApproveRejectAvailable: false,
  contractStatusDescription:
    '계약을 승인하시면 임차인이 결제를 진행할 수 있습니다.',
  hostPayTime: null,
}

export const 승인_대기 = {
  ...계약,
  contractStatus: ZContractStatus.enum.APPROVE_READY,
  approveTime: null,
  payDeadlineTime: null,
  isApproveRejectAvailable: true,
}

export const 취소 = {
  ...계약,
  contractStatus: ZContractStatus.enum.CANCEL,
}

export const 결제완료_입주_확인_전 = {
  ...계약,
  guestPhoneNumber: '010-1234-5678',
  contractStatus: ZContractStatus.enum.CONTRACT_COMPLETE,
  isRefundAvailable: true,
  cancelFee: 0, // 무료 취소
  cancelFeePercent: 0, // 무료 취소
  refundType: 'SOFT', // 무료 취소
  // cancelFee: 60000,
  // cancelFeePercent: 10,
}

export const 결제완료_입주_후_정산_전 = {
  ...계약,
  guestPhoneNumber: '010-1234-5678',
  contractStatus: ZContractStatus.enum.CONTRACT_COMPLETE,
  checkinTime: '2024-11-25',
}

export const 결제완료_정산_완료 = {
  ...계약,
  guestPhoneNumber: '010-1234-5678',
  contractStatus: ZContractStatus.enum.CONTRACT_COMPLETE,
  checkinTime: '2024-11-25',
  hostPayTime: '2024-11-27T15:25:20',
}

export const 결제취소_정산_전 = {
  ...계약,
  guestPhoneNumber: '010-1234-5678',
  contractStatus: ZContractStatus.enum.REFUND,
  serviceFee: 660,
  refundAmount: 200000,
  hostPayAmountBeforeOtherFee: 20000,
  hostPayAmount: 19340,
}

export const 결제취소_정산_완료 = {
  ...계약,
  guestPhoneNumber: '010-1234-5678',
  contractStatus: ZContractStatus.enum.REFUND,
  hostPayTime: '2024-11-27T15:25:20',
  serviceFee: 660,
  refundAmount: 200000,
  hostPayAmountBeforeOtherFee: 20000,
  hostPayAmount: 19340,
}

export const 연장_승인_대기 = {
  ...승인_대기,
  isExtend: true,
  checkinTime: '2024-11-25',
}

export const 연장_취소 = {
  ...취소,
  isExtend: true,
  checkinTime: '2024-11-25',
}

export const 연장_결제완료_입주_확인_전 = {
  ...결제완료_입주_확인_전,
  isExtend: true,
}

export const 연장_결제완료_입주_후_정산_전 = {
  ...결제완료_입주_후_정산_전,
  isExtend: true,
}

export const 연장_결제완료_정산_완료 = {
  ...결제완료_정산_완료,
  isExtend: true,
}

export const 연장_결제취소_정산_전 = {
  ...결제취소_정산_전,
  isExtend: true,
}

export const 연장_결제취소_정산_완료 = {
  ...결제취소_정산_완료,
  isExtend: true,
}
